const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Servicio para obtener usuarios administradores
 */
export const fetchAdminUsers = async (query = {}) => {
  try {
    const response = await fetch(`${API_URL}/user/admins`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error al obtener usuarios admin:', error);
    throw error;
  }
};
